import React, { useState } from 'react';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    mensaje: ''
  });

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Enviar a FormSubmit
    await fetch('https://formsubmit.co/ajax/estefangz@gmail.com', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(formData)
    });

    alert('¡Gracias por contactarnos!');

    // Reiniciar formulario
    setFormData({
      nombre: '',
      correo: '',
      mensaje: ''
    });
  };

  return (
    <section id="contacto" className="py-20 px-4 bg-gray-100">
      <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow">
        <h2 className="text-3xl font-bold mb-6 text-gray-800">Contáctanos</h2>
        <p className="text-gray-600 mb-6">
          ¿Tienes alguna consulta o necesitas más información? Completa el formulario y te responderemos lo antes posible.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="nombre" className="block font-medium">
              Nombre
            </label>
            <input
              type="text"
              name="nombre"
              id="nombre"
              required
              value={formData.nombre}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded"
            />
          </div>

          <div>
            <label htmlFor="correo" className="block font-medium">
              Correo
            </label>
            <input
              type="email"
              name="correo"
              id="correo"
              required
              value={formData.correo}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded"
            />
          </div>

          <div>
            <label htmlFor="mensaje" className="block font-medium">
              Mensaje
            </label>
            <textarea
              name="mensaje"
              id="mensaje"
              required
              rows="4"
              value={formData.mensaje}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition"
          >
            Enviar mensaje
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contacto;
